import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemortgageComponent } from './remortgage/remortgage.component';


import { ComponentsModule } from '../../components/components.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { AgmCoreModule } from '@agm/core';



@NgModule({
  declarations: [RemortgageComponent],
  imports: [
    CommonModule,
    ComponentsModule,
    NgbModule,
    AgmCoreModule.forRoot({
            apiKey: 'YOUR_KEY_HERE'
        }),
    RouterModule
  ]
})
export class RemortgageModule { }
